import styled from 'styled-components';

export const StyledLabel = styled.label`
  display: block;
`;

export const StyledDescription = styled.div`
  max-width: 550px;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledH3 = styled.h3`
  font-size: 14px;
  font-weight: 600;
`;

export const SectionContainer = styled.section`
  margin-top: 40px;
  margin-bottom: 40px;
`;
